export default{
    actions: {
        POSTS({commit}, value){
            commit('setPosts', value);
        }
    },

    mutations: {
        setPosts(state, payload){
            state.posts = payload;
        }
    },

    state: {
        posts: [],
    },

    getters: {
        POSTS(state){
            return state.posts;
        }
    }
}